import { Component, Inject, OnInit } from '@angular/core';
import { BzgModalRef, BZG_MODAL_DATA } from 'bz-genome-angular';

@Component({
  selector: 'biz-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent {
  constructor(public modalComponentRef: BzgModalRef,
    @Inject(BZG_MODAL_DATA) public data: { message: string, title: string, button?: string }) { }

  close() {
    this.modalComponentRef.close();
  }
  ok() {
    this.modalComponentRef.close('ok');
  }

}
